import { proxy } from 'valtio';

import * as wellsRappers from '../wells-rappers';
import * as createRappers from '../wells-rappers/create-rappers';
import { validate } from './validating';

import type { ClicksWellsStore, Depths } from '../types/clicks';

export const store: ClicksWellsStore = proxy({
    clicks: {},
});

export const setClick = (wellId: number, activePackID: number | null, depths: Depths) => {
    const rappersByWell = wellsRappers.getRappersByWell(wellId);

    if (!activePackID) return;

    if (validate.existRapper(activePackID, rappersByWell)) return;
    if (validate.intersection(depths.rel, rappersByWell)) return;

    if (wellId in store.clicks) {
        /*
            Debug log
        */
        // eslint-disable-next-line no-console
        console.log('---> Second Click <---');

        const clicks = store.clicks[wellId];

        let roof = clicks.first.rel;
        let bottom = depths.rel;

        if (roof > bottom) {
            roof = bottom;
            bottom = clicks.first.rel;
        }

        const isOverlying = validate.overlying({ roof, bottom }, rappersByWell);

        if (isOverlying) return;

        clicks.second = {
            px: depths.px,
            rel: depths.rel,
            abs: depths.abs,
        };

        /*
            Вызов метода модели wellsRappers на создание нового rapper-a
        */
        createRappers.createRapper(wellId, activePackID, store.clicks[wellId]);
        delete store.clicks[wellId];
    } else {
        /*
            Debug log
        */
        // eslint-disable-next-line no-console
        console.log('---> First Click <---');

        store.clicks[wellId] = {
            first: {
                px: depths.px,
                rel: depths.rel,
                abs: depths.abs,
            },
        };
    }
};

export const resetClicks = () => {
    store.clicks = {};
};
